module.exports = __webpack_public_path__ + "static/img/cif-fj.445499a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-fj.svg
// module id = cOC1
// module chunks = 2